import ContractsTaxiForwardingContractUpdateRequest, {
  ContractsTaxiForwardingContractUpdateRequestBody,
} from "./contracts-taxi-forwarding-contract-update.request";

const createBody = (
  request: ContractsTaxiForwardingContractUpdateRequest,
): ContractsTaxiForwardingContractUpdateRequestBody => {
  return {
    disabled: request.disabled,
    displayName: request.displayName,
    priority: request.priority,
  };
};

const contractsTaxiForwardingContractUpdateRequestFactory = {
  createBody,
};

export default contractsTaxiForwardingContractUpdateRequestFactory;
